import styled, { css } from 'styled-components'

export const Button = styled.button`
  color: ${({ theme }) => theme.colors.text};
  flex: 1;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`

type TIsDisableProps = {
  $isDisabled: boolean
}

export const DateLabel = styled.span<TIsDisableProps>`
  ${({ theme, $isDisabled = false }) => css`
    color: ${$isDisabled
      ? theme.colors.textFormDisabled
      : theme.colors.textForm};
  `};
  font-size: 16px;
`

type TPressableProps = {
  $borderColor: string
  $borderWidth: number
  $isDisabled?: boolean
}

export const DatePickerContainer = styled.div<TPressableProps>`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  ${({ $borderColor, $borderWidth, $isDisabled, theme }) => css`
    border-color: ${$isDisabled ? theme.colors.formBorderDisabled : $borderColor};
    border-width: ${$borderWidth}px;
    border-style: solid;
  `}
`

export const SelectLabel = styled.span<TIsDisableProps>`
  font-size: 16px;
  color: ${({ theme, $isDisabled }) =>
    $isDisabled ? theme.colors.textFormDisabled : theme.colors.textDisabled};
`
